<template>
    <!-- 点赞 -->
    <div
        :class="likeType === 'topic'
            ? 'f-icon-topic-evaluate' : 'f-icon-reply-evaluate'"
        @click="evaluate">
        <img :src="icon"
            :class="likeType === 'topic'
                ? 'f-icon-topic-evaluate-img' : 'f-icon-reply-evaluate-img'">
        <span class="f-icon-topic-evaluate-word">{{likeCount}}</span>
    </div>
</template>

<style lang="less">
    @import '../../../../assets/less/views/topic-content/icon/evaluate-icon.less';
</style>

<script>
import {limitMaxNum} from '@/utils/matchFilter';

export default {
    data() {
        return {
            topicLikeIcon: require('@/assets/images/icon-topic/like.png'),
            topicUnlikeIcon: require('@/assets/images/icon-topic/unlike.png'),
            replyLikeIcon: require('@/assets/images/icon-reply/like.png'),
            replyUnlikeIcon: require('@/assets/images/icon-reply/unlike.png')
        };
    },
    props: {
        likeType: {
            'type': String,
            'default': 'topic'
        },
        isEvaluated: {
            'type': Number,
            'default': 0
        },
        evaluationCount: {
            'type': Number,
            'default': 0
        }
    },
    computed: {
        icon: {
            get() {
                return this.likeType === 'topic'
                    ? (this.isEvaluated
                        ? this.topicLikeIcon : this.topicUnlikeIcon)
                    : (this.isEvaluated
                        ? this.replyLikeIcon : this.replyUnlikeIcon);
            }
        },
        likeCount: {
            get() {
                return limitMaxNum(this.evaluationCount);
            }
        }
    },
    methods: {
        evaluate() {
            if (this.likeType === 'topic') {
                this.$emit('topicEva');
            }
            else {
                this.$emit('replyEva');
            }
        }
    }
};
</script>
